import * as React from 'react'

function SvgAccessoriesIcon(props) {
  return (
    <svg
      width={40}
      height={40}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.232 11.773c1.27-2.062 4.267-2.062 5.536 0l7.553 12.273C31.653 26.212 30.095 29 27.553 29H12.447c-2.542 0-4.1-2.788-2.767-4.954l7.552-12.273Zm3.833 1.048a1.25 1.25 0 0 0-2.13 0L12.673 23h2.266l6.161-10.121-.034-.057ZM11.44 25l-.058.094A1.25 1.25 0 0 0 12.448 27H25.22L24 24.994V25H11.441Zm16.121 2a1.25 1.25 0 0 0 1.055-1.906l-6.34-10.304-1.074 1.763L27.562 27Zm-7.53-8.524L22.787 23h-5.507l2.754-4.523Z"
        fill="#000"
      />
    </svg>
  )
}

export default SvgAccessoriesIcon
